<template>
  <div :class="[`field-${field}`]">
    <TSelectableGroup
      v-model="value"
      :choices="choices"
      :default-choice-selected="defaultChoiceSelected"
      :error-messages="errors"
    />
    <FormErrorMessages class="my-3" :error-messages="errors" />
  </div>
</template>

<script>
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import TSelectableGroup from 'chimera/all/components/elements/TSelectableGroup'
import AbstractTSelectableGroupFormField from 'chimera/all/components/form/fields/AbstractTSelectableGroupFormField'

export const field = 'dwelling-type'
export default {
  name: 'DwellingTypeRadioField',

  components: {
    TSelectableGroup,
    FormErrorMessages,
  },

  extends: AbstractTSelectableGroupFormField,

  props: {
    field: {
      type: String,
      default: field,
    },
  },
}
</script>
